import type { FileAttachment } from '../../types';
import { formatSize } from './helpers';

function getFileIconPath(mimeType: string): string {
  if (mimeType === 'application/pdf') {
    return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/><path d="M10 13h4"/><path d="M10 17h4"/><path d="M10 9h1"/>';
  }
  if (mimeType.startsWith('image/')) {
    return '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>';
  }
  return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/>';
}

export function UserAttachmentCard({ att }: { att: FileAttachment }) {
  if (att.mimeType.startsWith('image/') && att.previewUrl) {
    return (
      <button
        type="button"
        className="user-attachment-image"
        data-expand="image"
        data-image-url={att.previewUrl}
        data-image-alt={att.filename}
        aria-label={att.filename}
      >
        <img src={att.previewUrl} alt={att.filename} loading="lazy" />
      </button>
    );
  }

  return (
    <div className="user-attachment-card">
      <svg
        className="user-attachment-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        dangerouslySetInnerHTML={{ __html: getFileIconPath(att.mimeType) }}
      />
      <div className="user-attachment-info">
        <span className="user-attachment-name">{att.filename}</span>
        <span className="user-attachment-size" dir="ltr">{formatSize(att.size)}</span>
      </div>
    </div>
  );
}
